import type { Seo } from '@sravni/types/lib/seo';

import type { TFindParams } from '../server/services/metadata';

import { ProxyClient } from './client/ProxyClient';

export const loadMetadata = async (params: TFindParams): Promise<Seo> => {
  const { data } = await ProxyClient.post('/metadata', params);

  return data;
};
